(() => {
  const Dine = (window.Dine = window.Dine || {});
  Dine.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  Dine.loadVideo = (video) => {
    video.querySelectorAll('source[data-src]').forEach((s) => {
      if (!s.getAttribute('src')) s.setAttribute('src', s.dataset.src);
    });
    if (video.dataset.loaded !== '1') { video.dataset.loaded = '1'; video.load(); }
  };

  /** Exécute fn une fois la page chargée : les vidéos ne concurrencent pas l'image principale. */
  Dine.afterLoad = (fn) => { if (document.readyState === 'complete') fn(); else addEventListener('load', fn, { once: true }); };

  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); revealObs.unobserve(e.target); } });
  }, { threshold: 0.12 });

  const videoObs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) {
        const gate = v.closest('[data-video-gate]');
        if (gate && !gate.classList.contains('is-active')) return;
        Dine.afterLoad(() => {
          Dine.loadVideo(v);
          if (!Dine.reducedMotion) v.play().catch(() => {});
        });
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '200px 0px', threshold: 0.01 });

  const parallax = new Set();
  Dine.scan = (root = document) => {
    root.querySelectorAll('[data-reveal]:not([data-observed])').forEach((el) => {
      el.dataset.observed = '1';
      if (Dine.reducedMotion) el.classList.add('is-in'); else revealObs.observe(el);
    });
    root.querySelectorAll('.coll__grid, .rail').forEach((grid) => {
      [...grid.children].forEach((card, i) => { if (card.classList.contains('card')) card.style.setProperty('--delay', `${Math.min(i, 8) * 60}ms`); });
    });
    root.querySelectorAll('video[data-lazy-video]:not([data-observed])').forEach((v) => { v.dataset.observed = '1'; videoObs.observe(v); });
    if (!Dine.reducedMotion) root.querySelectorAll('[data-parallax]').forEach((el) => parallax.add(el));
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      document.documentElement.classList.toggle('is-scrolled', scrollY > 40);
      parallax.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > innerHeight + 200) return;
        const d = r.top + r.height / 2 - innerHeight / 2;
        el.style.transform = `translate3d(0, ${(d * parseFloat(el.dataset.parallax)).toFixed(1)}px, 0)`;
      });
      document.dispatchEvent(new CustomEvent('dine:scroll'));
    });
  };
  addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', () => { Dine.scan(); onScroll(); });
  document.addEventListener('shopify:section:load', (e) => Dine.scan(e.target));
  const SECTION = 'cart-drawer';
  const drawer = () => document.getElementById('cart-drawer');
  const setCount = (n) => {
    document.querySelectorAll('[data-cart-count]').forEach((c) => {
      c.textContent = n; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
  };
  const rerender = (html) => {
    const old = drawer();
    const tpl = document.createElement('div');
    tpl.innerHTML = html || '';
    const fresh = tpl.querySelector('#cart-drawer');
    if (!fresh || !old) return false;
    const before = parseInt(old.dataset.remaining || '0', 10);
    const focusables = () => [...old.querySelectorAll('button, a[href], input')];
    const focusIndex = old.contains(document.activeElement) ? focusables().indexOf(document.activeElement) : -1;
    old.dataset.remaining = fresh.dataset.remaining || '0';
    old.dataset.count = fresh.dataset.count || '0';
    old.replaceChildren(...fresh.childNodes);
    if (focusIndex >= 0) {
      const list = focusables();
      const target = list[Math.min(focusIndex, list.length - 1)] || old.querySelector('[data-cart-close]');
      if (target) target.focus();
    }
    const n = parseInt(old.dataset.count || '0', 10);
    setCount(n);
    if (before > 0 && parseInt(old.dataset.remaining, 10) === 0 && n > 0 && !Dine.reducedMotion) confetti(old);
    return true;
  };
  const refresh = async (html) => {
    if (rerender(html)) return;
    try {
      const res = await fetch(`${location.pathname}?section_id=${SECTION}`);
      if (res.ok && rerender(await res.text())) return;
    } catch (e) { /* repli suivant */ }
    try {
      const cart = await (await fetch('/cart.js')).json();
      setCount(cart.item_count);
    } catch (e) { /* compteur inchangé */ }
  };
  const confetti = (el) => {
    const r = el.getBoundingClientRect();
    const colors = ['#C48E73', '#F6E3DA', '#1E1E1E', '#25D366', '#F3C9B4'];
    for (let i = 0; i < 40; i++) {
      const p = document.createElement('i');
      p.className = 'confetti';
      p.style.cssText = `left:${r.left + r.width / 2}px;top:${r.top + 90}px;background:${colors[i % 5]};--x:${Math.random() * 300 - 150}px;--y:${Math.random() * 260 - 60}px`;
      document.body.appendChild(p);
      setTimeout(() => p.remove(), 1300);
    }
  };
  const fly = (sourceEl) => {
    const img = sourceEl && (sourceEl.tagName === 'IMG' ? sourceEl : sourceEl.querySelector('img'));
    const target = document.getElementById('cart-toggle');
    if (!img || !target || Dine.reducedMotion) return Promise.resolve();
    const a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    const f = document.createElement('div');
    f.className = 'cart-flyer';
    f.style.cssText = `left:${a.left + a.width / 2 - 35}px;top:${a.top + a.height / 2 - 35}px;background-image:url("${img.currentSrc || img.src}")`;
    document.body.appendChild(f);
    requestAnimationFrame(() => { f.style.transform = `translate(${b.left - a.left - a.width / 2 + 20}px,${b.top - a.top - a.height / 2 + 20}px) scale(.25)`; f.style.opacity = '.3'; });
    return new Promise((r) => setTimeout(() => { f.remove(); r(); }, 800));
  };
  const post = async (url, body) => {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: SECTION, sections_url: location.pathname }) });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || String(res.status));
    return data;
  };
  const showError = (msg) => {
    const box = drawer() && drawer().querySelector('[data-cart-error]');
    if (box) { box.hidden = false; box.textContent = msg && !/^\d+$/.test(msg) ? msg : (box.dataset.default || box.textContent); }
    Dine.cart.open(true);
  };
  Dine.cart = {
    open(keepError = false) {
      const d = drawer();
      if (!d) return;
      const box = d.querySelector('[data-cart-error]');
      if (box && !keepError) box.hidden = true;
      if (!d.open) d.showModal();
    },
    close() { const d = drawer(); if (d && d.open) d.close(); },
    async add(id, quantity = 1, sourceEl) {
      try {
        const [data] = await Promise.all([post('/cart/add.js', { items: [{ id: Number(id), quantity }] }), fly(sourceEl)]);
        await refresh(data.sections && data.sections[SECTION]);
        Dine.cart.open();
      } catch (e) { showError(e.message); }
    },
    async addMany(ids, sourceEl) {
      try {
        const [data] = await Promise.all([post('/cart/add.js', { items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }), fly(sourceEl)]);
        await refresh(data.sections && data.sections[SECTION]);
        Dine.cart.open();
      } catch (e) { showError(e.message); }
    },
    async change(line, quantity) {
      try { const data = await post('/cart/change.js', { line, quantity }); await refresh(data.sections && data.sections[SECTION]); }
      catch (e) { showError(e.message); }
    },
  };
  document.addEventListener('dine:cart:open', () => Dine.cart.open());
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quick-add]');
    if (q) { e.preventDefault(); Dine.cart.add(q.dataset.quickAdd, 1, q.closest('[data-card], .upsell') || q); return; }
    const c = e.target.closest('[data-cart-change]');
    if (c) { Dine.cart.change(Number(c.dataset.cartChange), Number(c.dataset.qty)); return; }
    if (e.target.closest('[data-cart-close]') || e.target === drawer()) Dine.cart.close();
  });
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.card__swatch');
    if (!sw) return;
    const card = sw.closest('[data-card]');
    card.querySelectorAll('.card__swatch').forEach((s) => { s.classList.toggle('is-selected', s === sw); s.setAttribute('aria-pressed', String(s === sw)); });
    const img = card.querySelector('.card__img--a');
    if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; }
    const imgB = card.querySelector('.card__img--b');
    if (imgB && sw.dataset.imgB) { imgB.removeAttribute('srcset'); imgB.src = sw.dataset.imgB; }
    const quick = card.querySelector('.card__quick[data-quick-add]');
    if (quick) quick.dataset.quickAdd = sw.dataset.variant;
  });
  const businessDay = (d) => d.getDay() !== 0 && d.getDay() !== 6;
  const nextBusiness = (d) => { const x = new Date(d); do { x.setDate(x.getDate() + 1); } while (!businessDay(x)); return x; };
  Dine.shipDate = (now, cutoff) => {
    const d = new Date(now);
    if (businessDay(d) && d.getHours() < cutoff) return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12);
    const n = nextBusiness(d); return new Date(n.getFullYear(), n.getMonth(), n.getDate(), 12);
  };
  Dine.deliveryDate = (ship, days = 2) => { let d = new Date(ship); for (let i = 0; i < days; i++) d = nextBusiness(d); return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12); };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open-dialog]');
    if (o) { const d = document.getElementById(o.dataset.openDialog); if (d) d.showModal(); return; }
    const c = e.target.closest('[data-close-dialog]');
    if (c) c.closest('dialog').close();
  });
  Dine.shipText = (now, cutoff, tToday, tLater) => {
    const fmt = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\.$/, '');
    const s = Dine.shipDate(now, cutoff);
    const today = s.toDateString() === new Date(now).toDateString();
    return (today ? tToday : tLater).replace('{h}', cutoff).replace('{ship}', fmt(s)).replace('{date}', fmt(Dine.deliveryDate(s)));
  };
})();
